import axios from 'axios';
import { useEffect, useState } from 'react';
import { parseMarketOrderStatus } from '../../common/utils';
import orderIcon1 from '../../../img/orderIcon1.png';
import orderIcon2 from '../../../img/orderIcon2.png';
import orderIcon3 from '../../../img/orderIcon3.png';
import orderIcon4 from '../../../img/orderIcon4.png';
import orderIcon5 from '../../../img/orderIcon5.png';

function OrderCount(props) {
	const [OrderCountData, setOrderCountData] = useState([]);
	const orderIcons = [orderIcon1, orderIcon2, orderIcon3, orderIcon4, orderIcon5];

	const onSearch = (value) => {
		let marketOrderStatus = [];
		switch (value) {
			case '결제완료':
				marketOrderStatus = ['PAYED', 'ORDER_WAITING'];
				break;
			case '배송준비중':
				marketOrderStatus = ['DELIVERY_WAITING'];
				break;
			case '배송중':
				marketOrderStatus = ['DELIVERING'];
				break;
			case '배송완료':
				marketOrderStatus = ['DELIVERED'];
				break;
			case '클레임':
				marketOrderStatus = [
					'CANCEL_REQUEST',
					'EXCHANGE_REQUEST',
					'EXCHANGE_REDELIVERING',
					'RETURN_REQUEST',
					'COLLECTING',
				];
				break;
			default:
				break;
		}
		const newParams = {
			marketCode: ['smartstore', 'coupang', 'eleventh', 'kbpay', 'imembers', 'showdam', 'aphrozone'],
			vendorCode: [],
			marketOrderStatus,
			vendorOrderStatus: ['ORDER_WAITING', 'ORDERED', 'RELEASED', 'ERROR'],
			paymentDate: {
				before: null,
				after: null,
			},
			orderId: null,
			ordererName: null,
			manageCode: null,
		};
		// onSearch함수가 실행될 때마다 실행
		props.getCountParams(newParams);
	};
	useEffect(() => {
		const qs = require('qs');

		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getOrderCount`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				const newArr = Object.entries(res.data).map((m) => {
					return {
						text: m[0],
						count: m[1],
					};
				});
				setOrderCountData(newArr);
			})
			.catch();
	}, []);

	return (
		<div className='countBox'>
			<ul>
				{OrderCountData?.map((el, index) => (
					<li key={index} onClick={() => onSearch(el.text)}>
						<span className='countIcon'>
							<img src={orderIcons[index]} alt='orderIcon' />
						</span>
						<span className='countText'>
							<span>{parseMarketOrderStatus(el.text)}</span>
							<span>
								<strong>{el.count}</strong>건
							</span>
						</span>
					</li>
				))}
			</ul>
		</div>
	);
}

export default OrderCount;
